import styles from './style.postcss';

import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import is from 'is_js';
import { connect, StudentCard } from 'omni-common-ui';
import * as studentAccessors from '../accessors';
import * as studentActions from '../actions';

export class StudentInfoBar extends PureComponent {
  componentDidMount() {
    this.props.fetchStudentIfNeeded(this.props.studentId);
  }

  render() {
    const { student } = this.props;
    if (! is.existy(student)) {
      return null;
    }
    return <div className={styles.StudentInfoBar}>
      <StudentCard borderless backgroundless>
        <StudentCard.Profile className={styles.ReportStudentCard_profile}
            withoutBottomPadding
            name={student.firstName}
            surname={student.lastName}
            avatarUrl={student.avatarUrl}
            localName={student.localName}
            gender={student.gender} />
      </StudentCard>
    </div>;
  }
}

StudentInfoBar.propTypes = {
  studentId: PropTypes.string,
  student: PropTypes.object,
  fetchStudentIfNeeded: PropTypes.func,
};

export function mapStateToProps(state, ownProps) {
  const studentId = `${ownProps.params.studentId}`;
  const student = studentAccessors.getStudentById(state, studentId);
  return {
    studentId,
    student,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(studentActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentInfoBar);



// WEBPACK FOOTER //
// ./containers/Student/StudentInfoBar/index.jsx